module.exports = __webpack_public_path__ + "media/images/app/homepage/refer-friend-mobile-d290ee0844db88556235f5b03a66797e.webp";